import * as caseConverter from "change-object-case";
import { apiCaller } from "../api-caller";
import { ENDPOINTS, REQUEST_TYPES } from "../constants";

// ---- Zones ----
export const getCourierZonesAPI = (filter = {}) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}zones/`,
    params: caseConverter.snakeKeys({ ...filter })
  });

export const createCourierZoneAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}zones/`,
    data
  });

export const updateCourierZoneAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.PATCH,
    url: `${ENDPOINTS.COURIER}zones/${id}/`,
    data
  });

export const deleteCourierZoneAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.DELETE,
    url: `${ENDPOINTS.COURIER}zones/${id}/`
  });

export const reorderCourierZonesAPI = ({ zoneIds = [] }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}zones/reorder/`,
    data: { zone_ids: zoneIds }
  });

// ---- Center types (admin-configurable) ----
export const getCourierCenterTypesAPI = (filter = {}) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}center-types/`,
    params: caseConverter.snakeKeys({ ...filter })
  });

export const createCourierCenterTypeAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}center-types/`,
    data
  });

export const updateCourierCenterTypeAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.PATCH,
    url: `${ENDPOINTS.COURIER}center-types/${id}/`,
    data
  });

export const deleteCourierCenterTypeAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.DELETE,
    url: `${ENDPOINTS.COURIER}center-types/${id}/`
  });

// ---- Centers ----
export const getCourierCentersAPI = (filter = {}) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}centers/`,
    params: caseConverter.snakeKeys({ ...filter })
  });

export const createCourierCenterAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}centers/`,
    data
  });

export const updateCourierCenterAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.PATCH,
    url: `${ENDPOINTS.COURIER}centers/${id}/`,
    data
  });

export const deleteCourierCenterAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.DELETE,
    url: `${ENDPOINTS.COURIER}centers/${id}/`
  });

export const reorderCourierZoneCentersAPI = ({ zoneId, centerIds = [] }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}zones/${zoneId}/centers/reorder/`,
    data: { center_ids: centerIds }
  });

// ---- Couriers (profiles) ----
export const getCouriersAPI = (filter = {}) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}couriers/`,
    params: caseConverter.snakeKeys({ ...filter })
  });

export const createCourierAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}couriers/`,
    data
  });

export const updateCourierAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.PATCH,
    url: `${ENDPOINTS.COURIER}couriers/${id}/`,
    data
  });

// ---- Rounds ----
export const getCourierRoundsAPI = (filter = {}) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}rounds/`,
    params: caseConverter.snakeKeys({ ...filter })
  });

export const createCourierRoundAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}rounds/`,
    data
  });

export const updateCourierRoundAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.PATCH,
    url: `${ENDPOINTS.COURIER}rounds/${id}/`,
    data
  });

export const deleteCourierRoundAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.DELETE,
    url: `${ENDPOINTS.COURIER}rounds/${id}/`
  });

// ---- Round stops ----
export const getCourierRoundStopsAPI = roundId =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}rounds/${roundId}/stops/`
  });

export const createCourierRoundStopAPI = ({ roundId, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}rounds/${roundId}/stops/`,
    data
  });

export const deleteCourierRoundStopAPI = ({ roundId, id }) =>
  apiCaller({
    method: REQUEST_TYPES.DELETE,
    url: `${ENDPOINTS.COURIER}rounds/${roundId}/stops/${id}/`
  });

export const reorderCourierRoundStopsAPI = ({ roundId, stopIds = [] }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}rounds/${roundId}/stops/reorder/`,
    data: { stop_ids: stopIds }
  });

// ---- Round schedules ----
export const getCourierRoundSchedulesAPI = (filter = {}) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}round-schedules/`,
    params: caseConverter.snakeKeys({ ...filter })
  });

export const createCourierRoundScheduleAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}round-schedules/`,
    data
  });

export const updateCourierRoundScheduleAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.PATCH,
    url: `${ENDPOINTS.COURIER}round-schedules/${id}/`,
    data
  });

export const deleteCourierRoundScheduleAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.DELETE,
    url: `${ENDPOINTS.COURIER}round-schedules/${id}/`
  });

// ---- Shifts ----
export const getCourierShiftsAPI = (filter = {}) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}shifts/`,
    params: caseConverter.snakeKeys({ ...filter })
  });

export const createCourierShiftAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}shifts/`,
    data
  });

export const updateCourierShiftAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.PATCH,
    url: `${ENDPOINTS.COURIER}shifts/${id}/`,
    data
  });

export const deleteCourierShiftAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.DELETE,
    url: `${ENDPOINTS.COURIER}shifts/${id}/`
  });

// ---- Trips ----
export const getCourierTripsAPI = (filter = {}) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}trips/`,
    params: caseConverter.snakeKeys({ ...filter })
  });

export const getCourierTripAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}trips/${id}/`
  });

export const generateCourierTripsAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}trips/generate/`,
    data
  });

export const getCourierTripTasksAPI = tripId =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}trips/${tripId}/tasks/`
  });

export const getEligibleCouriersAPI = tripId =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}trips/${tripId}/eligible-couriers/`
  });

export const assignCourierTripAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}trips/${id}/assign/`,
    data
  });

export const cancelCourierTripAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}trips/${id}/cancel/`,
    data
  });

// ---- Trip operator workflow (Phase 4) ----
export const startCourierTripAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}trips/${id}/start/`
  });

export const deliverCourierTripAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}trips/${id}/deliver/`,
    data
  });

export const reachCourierTaskAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}tasks/${id}/reach/`,
    data
  });

export const dispatchCourierTaskAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}tasks/${id}/dispatch/`,
    data
  });

export const outcomeCourierTaskAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}tasks/${id}/outcome/`,
    data
  });

export const overrideGpsCourierTaskAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}tasks/${id}/override-gps/`,
    data
  });

// ---- Custody & manual jobs (Phase 5) ----
export const getCourierCustodyItemsAPI = taskId =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}tasks/${taskId}/custody-items/`
  });

export const createCourierCustodyItemAPI = ({ taskId, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}tasks/${taskId}/custody-items/`,
    data
  });

export const reconcileCourierCustodyItemAPI = ({ id, data = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}custody-items/${id}/reconcile/`,
    data
  });

export const createCourierManualJobAPI = (data = {}) =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}courier-jobs/`,
    data
  });

// ---- Reports & live monitor (Phase 6) ----
export const getCourierReportsAPI = () =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}reports/`
  });

export const getCourierReportAPI = ({ slug, filters = {} }) =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}reports/${slug}/`,
    params: caseConverter.snakeKeys({ ...filters })
  });

export const getCourierLiveMonitorAPI = () =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.COURIER}live-monitor/`
  });

// ---- Optimization (Phase 7) ----
export const optimizeCourierRoundStopsAPI = roundId =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}rounds/${roundId}/optimize-stops/`
  });

export const autoAssignCourierTripAPI = id =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.COURIER}trips/${id}/auto-assign/`
  });
